import { pixleeURL } from './constants';

function getStringTemplateFromSku ({
	page = 1, perPage = 24, filters = {}, productSku, sort = {}
}) {

	return `${pixleeURL}/api/v2/albums/from_sku?sku=${productSku}&page=${page}
	&per_page=${perPage}&api_key=6RnR9XarqCQlbcsek45O&filters=${filters}&sort=${sort}&timestamp=${Date.now()}`;

}

export default getStringTemplateFromSku;
